import React from "react";
import { Link } from "react-router-dom";
import { Button, ListItem, ListItemText } from "@mui/material";
import { ApplicationPaths } from "../../../../../services/authorizationService/ApiAuthorizationConstants";

const AnonymousView: React.FC = () => {
    return (
        <ListItem disablePadding>
            <Button component={Link} to={ApplicationPaths.Login} sx={{ color: "white", textTransform: "uppercase" }} color="success" variant="contained" size="small">
                <ListItemText primary="Login" />
            </Button>
        </ListItem>
    );
};

export default React.memo(AnonymousView);
